<div class="card-container" style="padding: 0; height: 100%">
  <div
    class="title-head"
    style="
      border-bottom: 1px solid black;
      background-color: #4dc3a3;
      border-radius: 9px 9px 0 0;
    "
  >
    <h1 class="main-tit" style="line-height: 2.2; margin: 0">
      FI Question Answer Data
    </h1>
  </div>
  <div style="min-height: 100%" class="text-center" *ngIf="!FIQuestionData">
    No Information Available!!
  </div>
  <div class="cnt-data" *ngIf="FIQuestionData" style="margin: 10px">
    <div class="family">
      <!-- <div class="name-sub" style="margin-left: auto;margin-right: auto;left:0;right: 0;">
            <h1 style="margin-bottom: 2px;">Income Details</h1>
        </div> -->
      <div class="cont">
        <div *ngIf="FIQuestionData && FIQuestionData.length > 0" class="mb-3">
          <table class="table table-bordered table-sm w-full mx-auto">
            <tr>
              <th>Done By:</th>
              <td>{{ FIQuestionData[0].TVR_Done_By }}</td>
              <th>Done On:</th>
              <td>{{ FIQuestionData[0].FI_DoneOn || "-" }}</td>
            </tr>
            <tr>
              <th>Remark:</th>
              <td colspan="3">{{ FIQuestionData[0].FI_Remark }}</td>
            </tr>
          </table>
        </div>
        <div *ngFor="let item of FIQuestionData">
          <div class="cont-Card">
            <div class="grd">
              <div class="grd-item1">English</div>
              <div class="grd-item">{{ item.FI_Question }}</div>
            </div>
            <div class="grd">
              <div class="grd-item1">Hindi</div>
              <div class="grd-item">{{ item.FI_Question_Hindi }}</div>
            </div>
            <div class="grd">
              <div class="grd-item1">Answer</div>
              <div class="grd-item" *ngIf="item.QuestionType != 'Upload'">
                {{ item.FIAnswer }}
              </div>
              <div
                class="grd-item"
                *ngIf="item.QuestionType == 'Upload' && item.FIAnswer != ''"
              >
                <a
                  href="{{ docBaseUrl }}{{ item.Application_No }}/{{
                    item.FIAnswer
                  }}"
                  target="_blank"
                >
                  {{ item.FIAnswer }}
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
